// libs
import {EventBus} from "@common/lib/event-bus";

// composable
import useCompetitorFactory from '@src/modules/analytics_v3/composables/useCompetitorsFactory'
import useCompetitorReport from "@src/modules/analytics_v3/composables/useCompetitorReport";

// constants
import {
    FACEBOOK_API_ENDPOINTS,
    FACEBOOK_ERROR_MESSAGES,
} from '@src/modules/analytics_v3/constants/constants'

export default function usePostEngagementByCompetitor() {
    const {
        fetchCompetitorInfo: fetchPostEngagementByCompetitor,
        apiResponse: postEngagementByCompetitorResponse,
        loading: postEngagementByCompetitorLoadingState
    } = useCompetitorFactory()
    const {reportId, dateRange, timeZone,} = useCompetitorReport()

    const getPostEngagementByCompetitorData = async (type = '', competitor_id = false) => {
        switch (type) {
            case 'facebook':
                await fetchFbPostEngagementByCompetitor(competitor_id)
                break
            default:
                break
        }
    }

    const fetchFbPostEngagementByCompetitor = async (competitor_id = false) => {
        if (!reportId.value && !competitor_id) return

        const payload = {
            _id: competitor_id || reportId.value,
            time_zone: timeZone.value,
            date_filter: dateRange.value,
        }

        try {
            await fetchPostEngagementByCompetitor(FACEBOOK_API_ENDPOINTS.POST_ENGAGEMENT_BY_COMPETITORS, payload, FACEBOOK_ERROR_MESSAGES.POST_ENGAGEMENT_BY_COMPETITORS)
            if(postEngagementByCompetitorResponse.value[0]?.facebook_id) EventBus.$emit('fetch-engagement-data', {name: postEngagementByCompetitorResponse.value[0].page_name, id: postEngagementByCompetitorResponse.value[0].facebook_id})
        } catch (error) {
        }
    }


    return {
        // data
        postEngagementByCompetitorLoadingState,
        postEngagementByCompetitorResponse,

        // methods
        getPostEngagementByCompetitorData
    }
}
